import {isLocalStorageAvailable} from "@/utils/localStorage";
import {useQuery} from "@tanstack/react-query";

/**
 * Hook to check if localStorage is available.
 */
export const useLocalStorageAvailability = () => {
  return useQuery({
    queryKey: ["localStorage", "availability"],
    queryFn: () => isLocalStorageAvailable(),
    staleTime: Infinity, // Cache indefinitely
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
